var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DownloadModal',{attrs:{"activeModal":_vm.downloadActive,"expiredStatus":_vm.expiredStatus,"closeModal":_vm.closeDialog,"fileLink":_vm.fileLink,"isIframe":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }